import React from "react";
// import { Link } from "react-router-dom";
import Logo from "./Logo";
import AuthOption from "./AuthOption";
import MainMenu from "./MainMenu";

const TopNavBar = () => {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
        <div className="container-fluid mx-3">
          <Logo />

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* main menu */}

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <MainMenu />
            <AuthOption />
          </div>
        </div>
      </nav>
    </>
  );
};

export default TopNavBar;
